import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import UserList from './../../components/lists/users';

class ContactsPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{ContactsPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <UserList />
                    </div>
                </div>
            </div>
        );
    }
}

ContactsPage.meta = {
    label: <FormattedMessage id={'contacts'} defaultMessage={'Contacts'} />,
    icon: 'contacts',
    action: () => history.push('/contacts'),
    locations: ['/contacts']
};

export default ContactsPage;



// WEBPACK FOOTER //
// ./src/pages/contacts/index.jsx